import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Rist Management section for selections tab
 */
const RiskManagementSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="risk-management-section-component"
    >
      <AccordionV2
        testId="risk-management"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Rist Management" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            The selection and judging process consists of a three-stage process:
          </p>

          <p>
            In Stage 1, all listed companies are subjected to a preliminary
            screening using the following sources:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Corporate governance rankings eg. Singapore Governance and
              Transparency Index score and ASEAN Corporate Governance Scorecard;
            </li>

            <li>Performance results e.g. return on equity;</li>

            <li>
              Potential ‘red flags&apos; of poor risk management e.g. SGX
              watchlist, significant unplanned incidents or events (using
              publicly available information);
            </li>
          </ul>

          <p>
            In Stage 2, a final shortlist of companies is evaluated against a
            set of detailed Risk Management review criteria.
          </p>

          <p>
            In Stage 3, a panel of judges reviews and evaluates the shortlisted
            candidates based on the information provided by the companies and
            evaluators. The panel of judges will also meet with and interview
            representatives from the final shortlisted candidates and rank them.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default RiskManagementSection;
